import React from 'react';
import {ButtonParams} from '../../types';
import Button from './Button';

export default ({label = '', ...attrs}: ButtonParams) => {
    label += ' ✔';

    return <Button {...attrs} label={label} />
}